export const SET_JURISDICTION = 'SET_JURISDICTION';
export const SET_JURISDICTION_BY_CODE = 'SET_JURISDICTION_BY_CODE';

export const FETCH_JURISDICTIONS = 'FETCH_JURISDICTIONS';
export const FETCH_JURISDICTIONS_SUCCESS = 'FETCH_JURISDICTIONS_SUCCESS';
export const FETCH_JURISDICTIONS_FAIL = 'FETCH_JURISDICTIONS_FAIL';
